import { render, staticRenderFns } from "./OxSelect.vue?vue&type=template&id=545af183&"
import script from "./OxSelect.vue?vue&type=script&lang=js&"
export * from "./OxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports